
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1025 1024","xmlns":"http://www.w3.org/2000/svg","width":"32.031","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M516 1024q-161.714 0-288.286-86T39.43 710.286q-33.143-74.857-38.286-172t14.857-190T79.429 170 181.714 31.429L175.43 192q6.285-8 38.857-8.857t40 8.857q24-46.286 91.714-78.857t134-33.714q-30.857 25.714-68.286 84.857t-33.428 93.428q14.285 4.572 35.714 7.715t36 4.285T488.857 272t28.857 1.714q8.572 2.857 5.429 26t-17.429 43.143q-2.857 4-9.428 10.572T464 373.714t-57.714 19.429l8.571 108-79.428-38.286q-10.286 24.572-4.286 46.572t20.571 38 37.429 23.714 46.286 3.714q29.142-5.143 56-19.714t47.714-25.714 42-10q34.857 2.285 51.143 18.857t11.143 37.143q-.572 1.142-1.429 3.142t-4.857 7.143-10.286 8.857-18 6-26.571.572Q548 655.429 499.714 678.57T380 695.43q42.286 34.857 92.857 47.142T569.143 746t88.286-29.714 73.142-50 46-59.429q24.572-52 22.286-110T777.43 389.143t-44.858-71.429q49.715 21.715 78.286 45.429t44 64.286q8.572-97.143-32.857-196T702.286 69.143q151.428 44 235.428 159.714T1024 524.571q1.143 72.572-23.143 145.715t-70.571 136-108 112-141.429 77.428T516 1024z"}})])
          )
        }
      }
    